export const trimFormData = (formData) =>
  Object.fromEntries(
    Object.entries(formData).map(([key, value]) => {
      if (typeof value === 'string') {
        return [key, value.trim()];
      }
      return [key, value];
    }),
  );
